import odata from 'odata-client';
import {
    GET_EMPLOYEE_ENTRIES_REQUEST,
    GET_EMPLOYEE_ENTRIES_ERROR,
    GET_EMPLOYEE_ENTRIES_SUCCESS,
    TOKEN_EXPIRED
} from '../../types';
import { getServiceUrl, getDefaultHeader } from '../../../utils';
import RESOURCES from '../../../api/resources';
import { showNotification } from '../../notification';

export const tokenExpired = () => ({    
    type: TOKEN_EXPIRED
});

export const getEmployeeEntriesRequest = () => ({
    type: GET_EMPLOYEE_ENTRIES_REQUEST,
});

export const getEmployeeEntriesError = errorOrResults => ({
    type: GET_EMPLOYEE_ENTRIES_ERROR,
    error: errorOrResults.message,
});

export const getEmployeeEntriesSuccess = payload => ({
    type: GET_EMPLOYEE_ENTRIES_SUCCESS,
    payload,
});

export default (pensumIds) => async (dispatch, getState) => {
    dispatch(getEmployeeEntriesRequest());

    const query = odata({service: getServiceUrl()}).resource(RESOURCES.EmployeeEntries);
    query.expand(RESOURCES.Employee)
    query.expand(`Pensum($select=ID)`);
    if (pensumIds && pensumIds.length > 0) {
        query.filter(`Pensum/ID in (${pensumIds})`)
    }
    const errorOrResult = await query.get({
        headers: {
            Authorization: `Bearer ${getState().user.token}`,
            ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const errorKey = "GENERAL_SERVER_ERROR";
                return new Error(errorKey);
            } else if (!ok) {
                console.log('get employee entries api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
                return new Error(errorKey);
            } else {
                const body = JSON.parse(res.body);
                const payload = body.value;
                const employeeEntriesById = {}
                payload.forEach(obj => {
                    employeeEntriesById[obj.ID] = obj
                })

                return employeeEntriesById;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(getEmployeeEntriesError(errorOrResult));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        /*showNotification(errorOrResult.message, { severity: "danger" })*/
        return;
    }

    dispatch(getEmployeeEntriesSuccess(errorOrResult));

    return errorOrResult;
};